import { useDatastore, DEPRECATED_useModulePublicData } from "util/datastore";
import { useEffect, useState } from "react";
import { LoadingScreen } from "component/banner";
import { Heading, Paragraph } from 'component/text';
import { View } from "react-native";
import { colorBorderPrimary, colorTextDisabled, colorTextPrimary, colorTextSecondary } from 'component/color';

export function useUserProfileModerationData({ userId }) {
    const [userProfileData, setUserProfileData] = useState(null);
    const datastore = useDatastore();

    const timestampLastModerationAction = DEPRECATED_useModulePublicData("moderation", ["user", userId, "timeLastModerationAction"]);
    useEffect(() => {
        const fetchUserProfileData = async () => {
            if (!userId) {
                return;
            }
            const userProfileDataResult = await datastore.callServerAsync("moderationZdf", "getUserProfileData", { userKey: userId });
            if (userProfileDataResult && JSON.stringify(userProfileDataResult) !== JSON.stringify(userProfileData)) {
                setUserProfileData(userProfileDataResult);
            }
        };
        fetchUserProfileData();
    }, [timestampLastModerationAction]);

    return userProfileData;
}

function CountBox({ count, label, disabled, formatParams }) {
    const textColorBlack = disabled ? colorTextDisabled : colorTextPrimary;
    const textColorGrey = disabled ? colorTextDisabled : colorTextSecondary;
    return (
        <View style={{ flex: 1, gap: 8 }}>
            <Heading level={1} text={count.toString()} type="large" weight="medium" color={textColorBlack} />
            <Paragraph color={textColorGrey} label={label} formatParams={formatParams} />
        </View>
    );
}

function CountBoxSeparator() {
    return <View style={{ flex: 0, borderLeftWidth: 1, borderColor: colorBorderPrimary, alignSelf: "stretch", marginHorizontal: 8 }} />;
}

export function ModDashboardUserStatistics({ userProfileData = {}, disabled = false }) {
    if (!userProfileData) {
        return <LoadingScreen />;
    }
    return (
        <View style={{ justifyContent: "space-between", flexDirection: "row", minWidth: 600 }}>
            <CountBox count={userProfileData.commentCount || 0} label="{noun}" formatParams={{ count: userProfileData.commentCount || 0, singular: 'comment & reply', plural: 'comments & replies' }} disabled={disabled} />
            <CountBoxSeparator />
            <CountBox count={userProfileData.rejectedCommentCount || 0} label="{noun}" formatParams={{ count: userProfileData.rejectedCommentCount || 0, singular: 'rejected comment', plural: 'rejected comments' }} disabled={disabled} />
            <CountBoxSeparator />
            <CountBox count={userProfileData.flagsGivenCount || 0} label="{noun}" formatParams={{ count: userProfileData.flagsGivenCount || 0, singular: 'reported comment', plural: 'reported comments' }} disabled={disabled} />
            <CountBoxSeparator />
            <CountBox count={userProfileData.flagsReceivedCount || 0} label="{noun}" formatParams={{ count: userProfileData.flagsReceivedCount || 0, singular: 'flagged comment', plural: 'flagged comments' }} disabled={disabled} />
            <CountBoxSeparator />
            <CountBox count={Object.keys(userProfileData.suspension?.warnings || {}).length || 0} label="{noun}" formatParams={{ count: Object.keys(userProfileData.suspension?.warnings || {}).length || 0, singular: 'user warning', plural: 'user warnings' }} disabled={disabled} />
        </View>
    );
}
